
export const oktaConfig = {
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: window.location.origin + (process.env.REACT_APP_OKTA_REDIRECT_URI || '/login/callback'),
  scopes: (process.env.REACT_APP_OKTA_SCOPES || 'openid,profile,email').split(','),
  pkce: process.env.REACT_APP_OKTA_PKCE === 'true'
};

